import { DeprecatedMaskedInput } from "common/form/inputs/masked_input";
import { DeprecatedFieldWrapper } from "common/form/enhancers/redux_form_field_wrapper";

/** @deprecated - please use components in common/core/form */
export const DeprecatedMaskedField = DeprecatedFieldWrapper(DeprecatedMaskedInput);
